module.exports = __webpack_public_path__ + "media/images/landing/second/photo9-119e24dfa1c2ccd49284846204a458e2.jpg";